export default "__VITE_ASSET__PSnuZ_Ed__"